// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a796423d","667":"44d408dd","977":"5844fbd2"}[chunkId] + ".chunk.js";
};